<route>
{
    "name": "suppliers-create",
    "meta": {
        "title": "Adaugare furnizor",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
    <modal-layout class="white">
        <v-card :flat="true">
            <v-toolbar class="primary">
                <v-btn
                    icon
                    color="white"
                    @click.native="redirectBack()"
                >
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title class="text-xs-center white--text">
                    Adaugare furnizor
                </v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap my-5>
                <v-flex xs12 md10 offset-md1 px-2>
                    <manage></manage>
                </v-flex>
            </v-layout>
        </v-card>
    </modal-layout>
</template>

<script>
    import ModalLayout from "Layouts/ModalLayout.vue";
    import Manage from "Components/suppliers/Manage.vue";

    export default {
        components: {
            ModalLayout,
            Manage
        },
        methods: {
            redirectBack() {
                let self = this;
                self.$nextTick(() => self.$nextTick(() => self.$router.go(-1)));
            }
        }
    };
</script>
